import React from 'react';
import RowMenuBar from 'main/components/show/cuesheet/itemCell/rowMenuBar.jsx';
import ItemSelectionState from 'main/components/show/cuesheet/itemCell/selectionState.jsx';
import ItemLock from 'main/components/show/cuesheet/itemCell/lock.jsx';
import classNames from 'classnames';

/**
 * Row MenuCell component
 */
export default React.createClass({
  displayName: 'RowMenuCell',

  propTypes: {
    user: React.PropTypes.object,
    item: React.PropTypes.any.isRequired,
    rowIndex: React.PropTypes.number.isRequired,
    checkSelectionStatus: React.PropTypes.func, //EditableCellType
    rowType: React.PropTypes.string, //RowType
  },

  contextTypes: {
    router: React.PropTypes.object.isRequired,
    user: React.PropTypes.object.isRequired,
  },

  render() {
    const { item } = this.props;

    let { rowSelected, user, rowIndex } = this.props;

    let wrapperClasses = classNames('cs-row-menu-cell-wrapper');
    let cellClasses = classNames('cs-row-menu-cell', 'cs-cell');

    return (
      <div className={wrapperClasses}>
        <div className={cellClasses}>
          <ItemLock {...this.props} isLocked={item.get('locked')} />
          <ItemSelectionState
            user={user}
            rowIndex={rowIndex}
            isSelected={rowSelected}
          />
          <RowMenuBar {...this.props} />
        </div>
      </div>
    );
  },
});
